require('./dist/ng-sortable');
module.exports = 'as.sortable';



//////////////////
// WEBPACK FOOTER
// ./~/ng-sortable/index.js
// module id = 1344
// module chunks = 1